var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"number":"number","type":"number","placeholder":_vm.placeholder,"min":_vm.minQuantity,"max":_vm.maxQuantity},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)},"blur":_vm.formatValue}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eda159aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/shared/components/InputNumber.vue
// module id = EXu4
// module chunks = 0